export default "__VITE_ASSET__e0a8c450__"